export default __webpack_public_path__ + "75bf079.png";